module.exports = __webpack_public_path__ + "img/jifen10.823915d2.png";